import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './search_end_results_message.module.scss';

export const SearchEndResultsMessage: FC = () => (
  <div className={styles.endOfResults}>
    <FormattedMessage id="search/SearchEndResultsMessage.tsx/1" />
  </div>
);
